import { Cluster, Commitment, CommitmentUsageHistoryUsage } from '@cast/types';
import { CloudIntegration } from '@cast/types-inventory';
import { CommitmentCloud, CommitmentsUsageSummary } from '@cast/types-pricing';

import { CommitmentCloudService, NormalizedCommitment } from './types';

/**
 * UI-level grouping of cloud services into tabs.
 * Most tabs map 1:1 to a CommitmentCloudService, but
 * AWS_CAPACITY_RESERVATION groups both ODCR and Capacity Block.
 */
export enum CommitmentTab {
  AZURE_RI = 'AZURE_RI',
  AZURE_SP = 'AZURE_SP',
  GCP_RESOURCE_CUD = 'GCP_RESOURCE_CUD',
  GCP_FLEX_CUD = 'GCP_FLEX_CUD',
  AWS_RI = 'AWS_RI',
  AWS_SP = 'AWS_SP',
  AWS_CAPACITY_RESERVATION = 'AWS_CAPACITY_RESERVATION',
  GCP_RESERVATION = 'GCP_RESERVATION',
}

export type GroupedCommitments = Record<CommitmentCloudService, Commitment[]>;

export type DerivedCommitmentUsageMetrics = {
  memoryUsedBytes: number | undefined;
  memoryUsedBytesCast: number | undefined;
  memoryUsedBytesOthers: number | undefined;
  memoryCommittedBytes: number | undefined;
  totalUsedPercent: number | undefined;
};

/** old = usage type from v1 legacy API */
export type CommitmentUsageMetrics = CommitmentUsageHistoryUsage &
  DerivedCommitmentUsageMetrics;

/** new = usage type from /pricing/v1beta service */
export type CommitmentUsageMetricsNew = CommitmentsUsageSummary &
  DerivedCommitmentUsageMetrics;

export type CommitmentHistoryItem = {
  usage: CommitmentUsageMetrics;
  timestamp: string;
  isForecast?: boolean;
};

export type ClusterWithAssignments = Cluster & {
  assignedCommitments: NormalizedCommitment[];
  utilization?: number;
};

export type CommitmentsCloudAssetIntegration = CloudIntegration & {
  provider: CommitmentCloud;
};

export type CommitmentsViewMode =
  | EnterpriseCommitmentsViewMode
  | ChildCommitmentsViewMode
  | StandardCommitmentsViewMode;

type EnterpriseCommitmentsViewMode = {
  type: 'enterprise';
  enterpriseOrgId: string;
};

type ChildCommitmentsViewMode = {
  type: 'child-org';
};

type StandardCommitmentsViewMode = {
  type: 'standard';
};
